import fullpage from "fullpage.js";
const fullPage = document.getElementById("fullpage");
let count = true;

if (fullPage) {
  const fullpageHome = new fullpage(fullPage, {
    licenseKey: "6FQKK-9MD77-DKR27-JS85H-YKXON",
    sectionSelector: "main > div, footer",
    fixedElements: ".site-header, .pum",
    css3: true,
    normalScrollElements: ".bg-engine-1, .bg-engine-2",
    scrollOverflow: true,
    lazyLoading: false,
    scrollingSpeed: 1000,
    keyboardScrolling: false,
    onLeave: function () {
      if (count === true) {
        jQuery('h1 code, h2 code, h3 code, h4 code, h5 code, h6 code, p code').each(function () {
          const $this = jQuery(this);
          jQuery({
            Counter: 0
          }).animate({
            Counter: $this.text()
          }, {
            delay: 10000,
            duration: 3500,
            easing: 'swing',
            step: function step() {
              $this.text(Math.ceil(this.Counter));
              return;
            }
          });
        });
        count = false;
      }
    }
  });
  document.addEventListener('keyup', event => {
    if (event.code === 'Space') {
      document.activeElement.value = document.activeElement.value + ' ';
    }
  });
  let fadeElementsHome = document.querySelectorAll('.home-hero [data-fade]');
  fadeElementsHome.forEach(el => {
    el.classList.add('show');

    if ('delay' in el.dataset) {
      const dataDelay = el.dataset.delay;
      const delay = dataDelay * 200;
      el.style.transitionDelay = delay + 'ms';
    }
  });
}